export const capitalizeString = (s) =>
  s && String(s[0]).toUpperCase() + String(s).slice(1);

export function formatToLongDate(isoString) {
  if (!isoString) return "";
  const date = new Date(isoString);
  if (isNaN(date)) return "";
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export function generateImageURL(path) {
  return `${process.env.REACT_APP_API_URL}${path}`;
}

export const formatName = (str) => {
  if (typeof str !== "string") return str;
  const lower = str.toLowerCase();
  if (lower === "received_at_the_warehouse") {
    return "Received at the warehouse";
  }
  if (lower === "shopping_completed") {
    return "Shopping Completed";
  }
  return str
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};


export const orderStatusEnum = {
  APPROVED: 'approved',
  RECIEVED: 'recieved',
  DELIVERED: 'delivered',
  AWAITING_APPROVAL: 'awaiting_approval',
};

/** Customer can approve/decline uploaded pictures in these statuses. */
export function isAwaitingPictureReview(status) {
  const normalized = String(status || "").toLowerCase();
  return (
    normalized === orderStatusEnum.AWAITING_APPROVAL ||
    normalized === orderStatusEnum.RECIEVED ||
    normalized === orderStatusEnum.DELIVERED
  );
}

/** Edit/delete disabled while pictures await review, after final states, or while on hold / in progress. */
export function isLockerItemEditDisabled(status) {
  const normalized = String(status || "").toLowerCase();
  return normalized !== "pending";
}

/** Customer cannot delete items in active intake or final states. */
export function isLockerItemDeleteDisabled(status) {
  const normalized = String(status || "").toLowerCase();
  if (isLockerItemEditDisabled(status)) return true;
  return (
    normalized === "pending" ||
    normalized === "on_hold" ||
    normalized === "shopping_in_progress"
  );
}


export const minimumTodayDateValidation = () => {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};


export const minimum18YearsDateValidation = () => {
  const today = new Date();
  today.setFullYear(today.getFullYear() - 18);
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

export const productStatusColors = {
  pending: { background: "#9C9C9C" },
  on_hold: { background: "#126ABC" },
  shopping_in_progress: { background: "#7B61FF" },
  shopping_completed: { background: "#00C046" },
  review: { background: "#9C9C9C" },
  wait_to_deliver: { background: "#FF8500" },
  un_delivered: { background: "#FF8500" },
  recieved: { background: "#126ABC" },
  delivered: { background: "#126ABC" },
  approved: { background: "#00C046" },
  rejected: { background: "#FF3850" },
  awaiting_approval: { background: "#E17B0B" },
  completed: { background: "#00C046" },
  item_delivered: { background: "#00C046" },
  received_at_the_warehouse: { background: "#126ABC" },
};

export const PRODUCT_STATUS_FILTER_OPTIONS = [
  { value: "all", label: "All Status" },
  { value: "pending", label: "Pending" },
  { value: "on_hold", label: "On Hold" },
  { value: "shopping_in_progress", label: "Shopping In Progress" },
  { value: "shopping_completed", label: "Shopping Completed" },
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" },
  { value: "review", label: "Review" },
  { value: "recieved", label: "Received" },
  { value: "awaiting_approval", label: "Awaiting Approval" },
  { value: "item_delivered", label: "Item Delivered" },
  { value: "received_at_the_warehouse", label: "Received at the warehouse" },
];

export const SHOPPER_STATUS_FILTER_OPTIONS = [
  { value: "all", label: "All Status" },
  { value: "active", label: "Active" },
  { value: "suspended", label: "Suspended" },
];

export const CUSTOMER_STATUS_FILTER_OPTIONS = SHOPPER_STATUS_FILTER_OPTIONS;

export const VIRTUAL_LOCKER_STATUS_FILTER_OPTIONS = [
  { value: "all", label: "All Status" },
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
  { value: "expired", label: "Expired" },
];

export const virtualLockerStatusColors = {
  active: "#00C046",
  inactive: "#FF8500",
  expired: "#FF3850",
};

export const AssignedStatusColors = {
  pending: { background: "#9C9C9C" },
  review: { background: "#9C9C9C" },
  wait_to_deliver: { background: "#FF8500" },
  un_delivered: { background: "#FF8500" },
  recieved: { background: "#126ABC" },
  delivered: { background: "#126ABC" },
  approved: { background: "#00C046" },
  rejected: { background: "#FF3850" },
  awaiting_approval: { background: "#E17B0B" },
  isShopperAssigned :{ background: "#00C046" },
  received_at_the_warehouse: { background: "#126ABC" },
};

export const productOrderType = {
  'self_drop': 'Self Drop',
  'personal_shopper': 'Personal Shopper',
  'online_shopping': 'Online Shopping',
  'pick_up': 'Pick up',
};

export const paymentStatusColors = {
  paid: "#00C046",
  unpaid: "#FF3850",
  not_paid: "#FF3850",
  partial_paid: "#FF8500",
};

export const paymentStatusLabels = {
  paid: "Paid",
  unpaid: "Unpaid",
  not_paid: "Not Paid",
  partial_paid: "Partial Paid",
};